import resolveBaseUrl from "../services";

export const amountToCurrency = (amount: number) => {
  return amount.toLocaleString("en-US");
};

export const formattedDate = (dateStr: string) => {
  if (dateStr !== undefined && dateStr != null && dateStr.length >= 10) {
    let date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } else {
    return dateStr;
  }
};

export const dateToDbFormat = (date: Date) => {
  var dd = String(date.getDate()).padStart(2, '0');
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = date.getFullYear();
  
  return yyyy + '-' + mm + '-' + dd;
};

export const currentDate = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();
  
  return yyyy + '-' + mm + '-' + dd;
};

export const invoiceStartDate = () => {

  var today = new Date();
  var date= new Date(today.getFullYear(), today.getMonth()+1, 0);
  
  var dd = String(date.getDate()).padStart(2, '0');
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = date.getFullYear();
  
  return yyyy + '-' + mm + '-01';
};


export const invoiceEndDate = () => {

  var today = new Date();
  var date= new Date(today.getFullYear(), today.getMonth()+1, 0);
  
  var dd = String(date.getDate()).padStart(2, '0');
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = date.getFullYear();
  
  return yyyy + '-' + mm + '-' + dd;
};

export const getForms = () => {
  return [
    {value: 'Kinder', text: 'Kinder'},
    {value: 'Nursery', text: 'Nursery'},
    {value: 'Pre-primary', text: 'Pre-primary'},
    {value: 'P1', text: 'P1'},
    {value: 'P2', text: 'P2'},
    {value: 'P3', text: 'P3'},
    {value: 'P4', text: 'P4'},
    {value: 'P5', text: 'P5'},
    {value: 'P6', text: 'P6'},
    {value: 'P7', text: 'P7'},
  ]
}

export const setCurrentTenant = (tenant: any) => {
  localStorage.setItem("__eyfort__tenant__", JSON.stringify({
    id: tenant.id,
  }))
}

export const currentTenant = () => {
  const current_user = localStorage.getItem("__eyfort__user__");
  const current_tenant = localStorage.getItem("__eyfort__tenant__");
  var tenant = { id: 0, name: "", logo: "", phone: "", email: ""};
  if (current_user) {
    const user = JSON.parse(current_user);
    if (current_tenant) {
      tenant = JSON.parse(current_tenant);
    } else {
      if (user.tenants.length > 0) {
        tenant = user.tenants[0];
      }
    }
  }
  return tenant;
};

export const allTenants = () => {
  let tenants: any = [];
  const current_user = localStorage.getItem("__eyfort__user__");
  if (current_user) {
    const user = JSON.parse(current_user);
    tenants = user.tenants;
  }
  return tenants;
} 

export const fullUrl = (url: string) => {
  const API_URL = "https://eyfort-ui.eygo.biz";
  if (url && !url.startsWith('http')) {
    url = API_URL + url;
  }
  return url;
};

export const generateRandomColors = (limit: number) => {
  const list: string[] = [];
  for(let i = 0; i < limit; i++) {
    var randomColor = "#000000".replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
    list.push(randomColor);
  }
  return list;
}

const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}; 

export const isLoggedIn = () => {
  const token = localStorage.getItem("__eyfort__access__token__");
  let result = false;
  if (token) {
    const decodedJwt = parseJwt(token);
    if (decodedJwt.exp * 1000 > Date.now()) {
      result = true;
    }
  }

  if (!result) {
    localStorage.removeItem("__eyfort__access__token__");
    localStorage.removeItem("__eyfort__user__");
    localStorage.removeItem("__eyfort__tenant__");
  }

  return result;
}

export   const round = (num: any) => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

export const taxCalculator = (item: any) => {
  let tax = 0;
  if (item.tax) {
    tax = item.amount - (item.amount/(1 + (item.tax.taxpct / 100)));
    tax = round(tax);
  }
  return tax;
}


export const getStorableUser = (data: any) => {

  const user = {
    id: data.id,
    avatar: `${resolveBaseUrl()}/${data.path}`,
    name: data.name,
    email: data.email,
  }

  return user;
}

export const can = (action: string, clazz: string, object: any = null) => {
  let result = false;
  const current_user = localStorage.getItem("__eyfort__user__");
  if (current_user) {
    const user = JSON.parse(current_user);
    if (clazz.length == 0 ) {
      result = true
    } else if (user.admin) {
      result = true;
    } else {
      const permissions = user.permissions[clazz];
      if (permissions && (permissions.includes(action) || permissions.includes('manage'))) {
        result = true
      }
    }
  }
  return result;
}
